<div
  *ngIf="trial"
  class="shrink-0 flex items-center justify-center gap-2 h-9 px-4 border-b"
  [style.background-color]="accent + '1A'"
  [style.border-bottom-color]="accent + '33'"
>
  <span class="text-xs font-semibold shrink-0" [style.color]="accent">{{
    headline
  }}</span>

  <span class="h-3 w-px shrink-0 bg-[#FFFFFF26] hidden sm:block"></span>

  <!-- Gives up its width first when the window narrows: the headline and CTA outrank it. -->
  <span class="text-xs text-[#B6BDC8] truncate min-w-0 hidden sm:block">{{
    detail
  }}</span>

  <a
    [routerLink]="subscriptionRoute"
    class="text-xs font-semibold hover:underline shrink-0 ml-1"
    [style.color]="accent"
    >Upgrade</a
  >
</div>
